import { render, staticRenderFns } from "./OwnerSelectDialog.vue?vue&type=template&id=6c547220&scoped=true&"
import script from "./OwnerSelectDialog.vue?vue&type=script&lang=js&"
export * from "./OwnerSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c547220",
  null
  
)

export default component.exports